module.exports = __webpack_public_path__ + "static/media/jungle.21a11564.jpg";